// extracted by mini-css-extract-plugin
module.exports = {"withActionSection":"Translations_with-action-section__3ppP5","dialogBanner":"Translations_dialog-banner__3HH7S"};